module.exports = __webpack_public_path__ + "img/BANNER_OPINION-01.4945f9bf.png";